// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3ioEF","footer":"ReportModalFilter_footer__3c4UY"};